import React from "react";
import "./AlertPopUp.css";
import { makeStyles } from "@material-ui/core/styles";

interface AlertProps {
  message: React.ReactNode;
  onClose: () => void;
  setStartAutoPilot: Function;
  startAutoPilot: boolean;
  setShowAutoPilot: Function;
}

const PopupAutoPilot: React.FC<AlertProps> = ({
  message,
  onClose,
  setStartAutoPilot,
  startAutoPilot,
  setShowAutoPilot,
}) => {
  const handleClick = () => {
    onClose();
  };

  const handleClick2 = () => {
    window.localStorage.setItem("TrialEndAutoPilot", "false");
    setShowAutoPilot(false);
    setStartAutoPilot((prevShow: any) => {
      console.log(!prevShow);
      return true;
    });
  };
  //css propriety

  const useStyles = makeStyles({
    proceed: {
      backgroundColor: "#4caf50",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      "&:hover": {
        backgroundColor: "#388e3c",
      },
    },
    close: {
      backgroundColor: "red",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
      "&:hover": {
        backgroundColor: "darkred",
      },
    },
  });
  const classes = useStyles();

  return (
    <div className="alert-overlay">
      <div className="alert">
        <div style={{ width: "45vh" }}>
          <h1 style={{ display: "flex", justifyContent: "center" }}>
            AutoPilot
          </h1>
          <p>
            By using the autopilot, a conversation will be started and carried
            on automatically. <br />
            This will cause a reduction of 1 of the maximum number of available
            conversations; moreover, the chat widget will be blocked until the
            end of the automatic conversation.
            <br /> Anytime, you can click on the "Pause" button to stop the
            automatic conversation, and reset it using the "Reset" button.
            <br />
            Select <b>Proceed</b> to start the conversation."
            <br />
          </p>
        </div>

        <div className="alert-body">{message}</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button className={classes.proceed} onClick={handleClick2}>
            Proceed
          </button>
          <button className={classes.close} onClick={handleClick}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupAutoPilot;
